import React from 'react';
import SignerDetails from './components/SignerDetails/SignerDetails';
import SignDocument from './components/SigningWithoutBankId/SignDocument';
import EmailAuthentication from './components/SigningWithoutBankId/EmailAuthentication';
import SigningResponse from './components/SigningWithoutBankId/SigningResponse';
import NotFound from './components/NotFound/index';
import BankIDConsent from './components/BankIDConsent/BankIDConsent';
import { Routes, Route } from 'react-router-dom';
import Callback from './components/Callback/Callback';

const AppRoutes = () => (
	<Routes >
		<Route path="/signerdetails" element={<SignerDetails />} />
		<Route exact path='/' element={<BankIDConsent />} />
		<Route path='/authentication' element={<EmailAuthentication />} />
		<Route path='/signing' element={<SignDocument />} />
		<Route path='/signingresult' element={<SigningResponse />} />
		<Route path="/callback" element={<Callback />} />
		<Route path="*" element={<NotFound />} />
	</Routes>
);

export default AppRoutes;